

















import Vue from 'vue'

export default Vue.extend({
  name: 'RemoteControlButton',

  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    tooltipPlacement: {
      type: String,
      default: 'bottom',
    },
    tooltipText: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      required: true,
    },
  },

  computed: {
    iconClassName(): string {
      return `ddi-${this.iconName}`
    },
  },
})
